import {Component, EventEmitter, Output} from '@angular/core';
import {WholesalerIntegrationStepsEnum} from '../../../../interfaces/WholesalerIntegrationStepsEnum';

@Component({
  selector: 'app-gather-credentials',
  templateUrl: './gather-credentials.component.html',
  styleUrls: ['./gather-credentials.component.scss'],
})
export class SelectTypeComponent {
  @Output() cancel: EventEmitter<void> = new EventEmitter();
  @Output() nextStep: EventEmitter<WholesalerIntegrationStepsEnum> = new EventEmitter();

  WholesalerIntegrationStepsEnum = WholesalerIntegrationStepsEnum;

  constructor() {
  }

}
